import PropTypes from 'prop-types'

const Pagination = ({ pagination, setPageNo, showTotal = true }) => {
  return (
    <div className='pagination'>
      {/* Display total count of items, if enabled */}
      {showTotal && <p className='total'>Total: {pagination?.total}</p>}

      <div style={{ display: 'flex', alignItems: 'center' }}>
        {/* Previous Page Button */}
        {pagination?.hasPreviousPage && (
          <button
            className='paginationBtn'
            onClick={() =>
              setPageNo(
                pagination.nextPage
                  ? pagination.nextPage - 2 // Go to the previous page
                  : pagination.totalPages - 1 // Handle edge case for the last page
              )
            }
          >
            <i className='bi bi-caret-left'></i>
          </button>
        )}

        {/* Display Current Page and Total Pages */}
        {(pagination?.nextPage || pagination?.hasPreviousPage) && (
          <span>
            Page{' '}
            {
              pagination.nextPage
                ? pagination.nextPage - 1 // Current page is derived from the nextPage value
                : pagination.totalPages // Handle edge case for the last page
            }{' '}
            of {pagination?.totalPages}
          </span>
        )}

        {/* Next Page Button */}
        {pagination?.hasNextPage && (
          <button
            className='paginationBtn'
            onClick={() => setPageNo(pagination.nextPage)} // Go to the next page
          >
            <i className='bi bi-caret-right'></i>
          </button>
        )}
      </div>
    </div>
  )
}

Pagination.propTypes = {
  pagination: PropTypes.shape({
    total: PropTypes.number, // Total number of items
    totalPages: PropTypes.number, // Total number of pages
    hasPreviousPage: PropTypes.bool, // If there is a previous page
    hasNextPage: PropTypes.bool, // If there is a next page
    nextPage: PropTypes.number, // The number of the next page
  }).isRequired,
  setPageNo: PropTypes.func.isRequired, // Function to update the current page
  showTotal: PropTypes.bool, // Flag to show the total count of items
}

export default Pagination
